const translations = {
    addServiceItem: 'Add Service Item'
};

export default translations;
